import { useEffect, useState } from "react";
import { api } from "./api";

export function useContent() {
  const [content, setContent] = useState(null);
  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);
  return content;
}
